import Container from '../../atoms/container/floatingMenuContainer';
import List from '../list/floatingMenu/floatingMenuList';
import { floatingMenuSelector } from '../../../../shared/store/slices/floatingMenu.slice';
import { useAppSelector } from '../../../../shared/store/hooks';

function FloatingMenu() {
  const { open, position } = useAppSelector(floatingMenuSelector);

  return open ? (
    <Container x={position?.x} y={position?.y}>
      <List />
    </Container>
  ) : null;
}

export default FloatingMenu;
